import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';
import { getScreenOrientation, readHeights, isHeaderSticky } from '~js/utils/utils';

let screenOrientation = getScreenOrientation();



export function setVars() {
  calcVars();
}

export function resizeVars() {
  // restrict the heights that are changed on resize to avoid iOS jump when URL bar is shown and hidden
  calcVars(true);
}

function calcVars(checkOrientation = false) {
  const body = document.querySelector(s.selectors$1b.body);
  const hasCollectionFilters = document.querySelector(s.selectors$1b.collectionFilters);
  const hasLogoTextLink = document.querySelector(s.selectors$1b.logoTextLink) !== null;

  let {
    windowHeight,
    headerHeight,
    headerInitialHeight,
    announcementBarHeight,
    footerHeight,
    collectionStickyBarHeight,
  } = readHeights();

  if (hasLogoTextLink) headerHeight = recalcHeaderHeight();

  const contentFullHeight =
    window.isHeaderTransparent && checkFirstSectionTransparency()
      ? windowHeight - announcementBarHeight
      : windowHeight - headerInitialHeight - announcementBarHeight;
  let fullHeight = isHeaderSticky() ? windowHeight - window.stickyHeaderHeight : windowHeight;
  const isCollectionPage = body.classList.contains(c.classes$_.templateCollection);
  const isSearchPage = body.classList.contains(c.classes$_.templateSearch);
  const isPageWithFilters = (isCollectionPage && hasCollectionFilters) || (isSearchPage && hasCollectionFilters);

  document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
  document.documentElement.style.setProperty('--content-full', `${contentFullHeight}px`);
  document.documentElement.style.setProperty('--content-min', `${windowHeight - headerHeight - footerHeight}px`);
  document.documentElement.style.setProperty('--collection-sticky-bar-height', `${collectionStickyBarHeight}px`);

  if (isPageWithFilters) fullHeight = windowHeight;

  if (!checkOrientation) {
    document.documentElement.style.setProperty('--full-height', `${fullHeight}px`);
    return;
  }

  const currentScreenOrientation = getScreenOrientation();
  if (currentScreenOrientation !== screenOrientation) {
    // Only update the heights on screen orientation change
    document.documentElement.style.setProperty('--full-height', `${fullHeight}px`);

    // Update the screen orientation state
    screenOrientation = currentScreenOrientation;
  }
}

function checkFirstSectionTransparency() {
  const firstSection = document.querySelector(s.selectors$1b.main).firstElementChild;
  return firstSection.classList.contains(c.classes$_.supportsTransparentHeader);
}

function recalcHeaderHeight() {
  document.documentElement.style.setProperty('--header-height', 'auto');
  document.documentElement.style.setProperty('--header-sticky-height', 'auto');

  // Header is declared here to avoid `offsetHeight` returning zero when the element has not been rendered to the DOM yet in the Theme editor
  const header = document.querySelector(s.selectors$1b.header);
  const resetHeight = header.offsetHeight;

  // requestAnimationFrame method is needed to properly update the CSS variables on resize after they have been reset
  requestAnimationFrame(() => {
    document.documentElement.style.setProperty('--header-height', `${resetHeight}px`);
    document.documentElement.style.setProperty('--header-sticky-height', `${resetHeight}px`);
  });

  return resetHeight;
}